import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	SubNavContentContainer,
	SubNavContainer
} from './subNavStyles';
import SvgHeader from './SvgHeader';
import SvgBlock from './SvgBlock';
import SubNavList from './SubNavList';
import SubNavAdSpace from './SubNavAdSpace';

class SubNav extends PureComponent {
	render () {
		const {
			slug,
			accentColor,
			svgProps,
			onMouseEnter,
			onMouseLeave,
			iconSize,
			metaChildren,
			type,
			ads,
			contentful
		} = this.props;

		return (
			<SubNavContainer
				onMouseLeave={onMouseLeave}
				onMouseEnter={onMouseEnter}
				accentColor={accentColor}
			>
				<SvgHeader {...svgProps} />
				<SubNavContentContainer>
					<SvgBlock {...svgProps} iconWidth={iconSize} />
					<SubNavList
						slug={slug}
						items={metaChildren}
						type={type}
						multiColumn={metaChildren.length > 1}
					/>
					{contentful && (
						<SubNavAdSpace slug={slug} ads={ads} />
					)}
				</SubNavContentContainer>
			</SubNavContainer>
		);
	}

	static defaultProps = {
		ads: [],
		metaChildren: [],
		svgProps: {},
	};

	static propTypes = {
		slug: PropTypes.string,
		accentColor: PropTypes.string,
		svgProps: PropTypes.object,
		onMouseLeave: PropTypes.func,
		onMouseEnter: PropTypes.func,
		iconSize: PropTypes.number,
		metaChildren: PropTypes.array,
		type: PropTypes.string,
		contentful: PropTypes.bool,
		ads: PropTypes.array,
	}
}

export default SubNav;
